import { Tooltip, Button, Upload, Input } from 'antd';
import {
	InfoCircleOutlined,
	CheckCircleFilled,
	UploadOutlined,
	EyeOutlined,
	DeleteOutlined,
} from '@ant-design/icons';

import useUploadDocument from '../../Hooks/useUploadDocument/useUploadDocument';

import { IUploadDocument } from './IUploadDocument';
import './UploadDocument.scss';

const UploadDocument = (props: IUploadDocument) => {
	const {
		className = '',
		translations,
		mandatory,
		oneRow,
		disabled,
		error,
		allowMultipleDocuments = false,
		maxDocuments,
	} = props;

	const {
		acceptedFormats,
		handleSelectFile,
		mainButtonLabel,
		canUploadPendingFiles,
		displayCustomFileName,
		isOcrLoading,
		fileUrl,
		handleCustomFileNameChange,
		handleMainButtonClick,
		handleRemoveQueuedFile,
		pendingFiles,
		shouldDisableFileDialog,
		shouldShowCustomFileNameInput
	} = useUploadDocument(props);

	return (
		<div className={ `upload-document ${oneRow ? 'one-row' : ''} ${className}` }>
			<label
				className={ `${mandatory ? 'mandatory' : ''} ${error ? 'error-input' : ''} ` }
			>
				{translations.label}{' '}
				<Tooltip title={translations?.uploadDocumentTooltip}>
					<InfoCircleOutlined/>
				</Tooltip>{' '}
			</label>
			{
				shouldShowCustomFileNameInput
					? (
						<Input
							value={displayCustomFileName}
							onChange={(event) => handleCustomFileNameChange(event.target.value)}
							placeholder={translations.fileNamePlaceholder ?? 'Document name'}
							disabled={disabled || isOcrLoading}
							className='upload-file-name-input'
							addonBefore={translations.fileNameLabel ?? 'File name'}
						/>
					) : null
			}
			<div className={ `upload-container-files ${fileUrl ? 'has-file' : ''}` }>
				<Upload
					beforeUpload={handleSelectFile}
					openFileDialogOnClick={!shouldDisableFileDialog}
					showUploadList={false}
					maxCount={allowMultipleDocuments ? maxDocuments : 1}
					multiple={allowMultipleDocuments}
					accept={acceptedFormats}
					disabled={disabled}
				>
					<Button
						className='upload-button'
						disabled={disabled || isOcrLoading}
						loading={isOcrLoading}
						danger={error}
						onClick={handleMainButtonClick}
						icon={
							fileUrl
								? (
									<CheckCircleFilled/>
								) : (
									<UploadOutlined />
								)
						}
					>
						{mainButtonLabel}
					</Button>
				</Upload>
				{
					fileUrl
						? (
							<Button
								className='upload-file-view-button'
								onClick={() => window.open(fileUrl, '_blank')}
								disabled={isOcrLoading}
							>
								<EyeOutlined />
							</Button>
						) : null
				}
			</div>
			{
				canUploadPendingFiles
					? (
						<div className='upload-pending-files'>
							<div className='upload-pending-files-label'>
								{translations.selectedDocumentsLabel ?? 'Selected documents'}: {pendingFiles.length}
							</div>
							<div className='upload-pending-files-list'>
								{pendingFiles.map((file) => (
									<div
										className='upload-pending-file'
										key={`${file.name}-${file.lastModified}-${file.size}`}
									>
										<span className='upload-pending-file-name'>{file.name}</span>
										<Button
											type='text'
											size='small'
											icon={<DeleteOutlined />}
											onClick={() => handleRemoveQueuedFile(file)}
											disabled={disabled || isOcrLoading}
										/>
									</div>
								))}
							</div>
						</div>
					) : null
			}
		</div>
	);
};

export default UploadDocument;
